export default __webpack_public_path__ + "static/media/delete.03ce3a4c.svg";